module.exports = __webpack_public_path__ + "media/images/core_values/innovation-d208fff707bdf245bea5d590619ad427.png";